import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";

import { BrowserRouter } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

document.body.style.backgroundColor = "black";
document.body.style.color = "white";

root.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>
);
